import { setTree } from 'actions/dashboardEdit';
import { cloneDeep } from 'lodash';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fillDefaultTree, Operator } from 'utils/parserTree';
import { v4 } from 'uuid';
import useTree from './useTree';

type UseAddTreeToStore = (fs: string, metricIndex: number) => void;

const useAddDashboardEditTreeToStore: UseAddTreeToStore = (fs, metricIndex) => {
  const dispatch = useDispatch();
  const { data } = useTree(fs);

  useEffect(() => {
    if (data) {
      const fullTree = fillDefaultTree(cloneDeep(data));
      if (fullTree.op) {
        dispatch(setTree({ tree: fullTree, metricIndex }));
      }
    } else {
      dispatch(
        setTree({
          tree: {
            op: Operator.AND,
            data: [],
            id: v4(),
          },
          metricIndex,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, fs, data]);
};

export default useAddDashboardEditTreeToStore;
